<template>
  <div class="row p-4">
    <div class="col-lg-8 mb-2">
      <h3>COPIAR CANDIDATO(AS)</h3>
    </div>
    <div class="col-lg-4 mb-2">
      <h3>VAGA:</h3>
    </div>
    <div class="col-lg-8">
      <table class="table_jovool">
        <thead class="headerTable">
          <tr>
            <td></td>
            <td>NOME</td>
            <td>EMAIL</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="candidate in candidates" :key="candidate.id">
            <td>
              <input
                type="checkbox"
                name="selectCandidate"
                :value="candidate"
                v-model="candidates_selected"
              />
            </td>
            <td>
              <span class="d-block">{{ candidate.name }}</span>
            </td>
            <td>
              <span class="d-block">{{ candidate.email }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-lg-4">
      <VueSuggestion
        searchURL="/recruiters/jobs_search"
        responseDataName="jobs"
        :whenSelected="JobSelected"
      />
      <button
        class="btn btn-primary full mt-2"
        :disabled="job_id == 0"
        :class="{ disabled: job_id == 0 }"
        @click="copy"
      >
        COPIAR CANDIDATOS(AS)
      </button>
    </div>
  </div>
</template>

<script>
import VueSuggestion from "./VueSuggestion.vue";

export default {
  props: ["candidates"],
  components: { VueSuggestion },
  data: () => ({
    candidates_selected: [],
    job_id: 0,
    business_id: 0,
  }),
  mounted() {
    this.candidates_selected = this.candidates;
  },
  methods: {
    JobSelected(item) {
      this.job_id = item.id;
      this.business_id = item.business_id;
    },
    copy() {
      let apply = {
        job_id: this.job_id,
        business_id: this.business_id,
        candidates: this.candidates_selected.map((candidate) => ({
          id: candidate.id,
          remuneration: candidate.remuneration,
        })),
      };
      axios.post("/recruiters/copy_candidates", { apply }).then((response) => {
        if (response.data.status) {
          this.$toast.success("Candidatos(as) copiados(as) com sucesso!");
          this.$emit("close");
          return;
        }

        this.$toast.error("Falha ao copiar candidatos(as)");
      });
    },
  },
};
</script>